import React from 'react';

const CohortAnalysisPanel = ({ data }) => {
  if (!data || data?.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-muted-foreground text-sm">
        No cohort data available
      </div>
    );
  }

  const getRetentionColor = (value) => {
    if (value >= 70) return 'bg-success/20 text-success';
    if (value >= 50) return 'bg-warning/20 text-warning';
    return 'bg-error/20 text-error';
  };

  return (
    <div className="space-y-4">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-2 px-3 text-muted-foreground font-medium">Cohort</th>
              <th className="text-center py-2 px-3 text-muted-foreground font-medium">Size</th>
              <th className="text-center py-2 px-3 text-muted-foreground font-medium">Day 1</th>
              <th className="text-center py-2 px-3 text-muted-foreground font-medium">Day 7</th>
              <th className="text-center py-2 px-3 text-muted-foreground font-medium">Day 14</th>
              <th className="text-center py-2 px-3 text-muted-foreground font-medium">Day 30</th>
              <th className="text-center py-2 px-3 text-muted-foreground font-medium">Premium %</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((cohort, index) => (
              <tr key={index} className="border-b border-border/50">
                <td className="py-2 px-3 font-medium text-foreground">{cohort?.cohort}</td>
                <td className="py-2 px-3 text-center text-muted-foreground">{cohort?.size?.toLocaleString()}</td>
                <td className="py-2 px-3 text-center">
                  <span className={`inline-block px-2 py-1 rounded font-medium ${getRetentionColor(cohort?.day1)}`}>
                    {cohort?.day1}%
                  </span>
                </td>
                <td className="py-2 px-3 text-center">
                  <span className={`inline-block px-2 py-1 rounded font-medium ${getRetentionColor(cohort?.day7)}`}>
                    {cohort?.day7}%
                  </span>
                </td>
                <td className="py-2 px-3 text-center">
                  <span className={`inline-block px-2 py-1 rounded font-medium ${getRetentionColor(cohort?.day14)}`}>
                    {cohort?.day14}%
                  </span>
                </td>
                <td className="py-2 px-3 text-center">
                  <span className={`inline-block px-2 py-1 rounded font-medium ${getRetentionColor(cohort?.day30)}`}>
                    {cohort?.day30}%
                  </span>
                </td>
                <td className="py-2 px-3 text-center">
                  <span className="font-semibold text-primary">{cohort?.premiumRate}%</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Insights */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
        <div className="p-4 bg-muted/30 rounded-lg">
          <p className="text-xs text-muted-foreground mb-1">Avg Day 1 Retention</p>
          <p className="text-2xl font-bold text-foreground">
            {(data?.reduce((sum, c) => sum + c?.day1, 0) / data?.length)?.toFixed(1)}%
          </p>
        </div>
        <div className="p-4 bg-muted/30 rounded-lg">
          <p className="text-xs text-muted-foreground mb-1">Avg Day 30 Retention</p>
          <p className="text-2xl font-bold text-foreground">
            {(data?.reduce((sum, c) => sum + c?.day30, 0) / data?.length)?.toFixed(1)}%
          </p>
        </div>
        <div className="p-4 bg-muted/30 rounded-lg">
          <p className="text-xs text-muted-foreground mb-1">Avg Premium Rate</p>
          <p className="text-2xl font-bold text-primary">
            {(data?.reduce((sum, c) => sum + c?.premiumRate, 0) / data?.length)?.toFixed(1)}%
          </p>
        </div>
      </div>
    </div>
  );
};

export default CohortAnalysisPanel;